export const CREATE_RECIPE = 'CREATE_RECIPE'
export const EDIT_RECIPE = 'EDIT_RECIPE'
export const EDIT_RECIPE_ERROR = 'EDIT_RECIPE_ERROR'
export const FETCH_RECIPES_SUCCESS = 'FETCH_RECIPES_SUCCESS'
export const FETCH_RECIPES_FAILED = 'FETCH_RECIPES_FAILED'
export const FETCH_RECIPES_PENDING = 'FETCH_RECIPES_PENDING'
export const SELECT_RECIPE = 'SELECT_RECIPE'
export const CREATE_RECIPE_ERROR = 'CREATE_RECIPE_ERROR'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS'
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS'
export const SIGNUP_ERROR = 'SIGNUP_ERROR'
export const FETCH_RECIPES_BY_ID_SUCCESS = 'FETCH_RECIPES_BY_ID_SUCCESS'
export const FETCH_RECIPES_BY_ID_PENDING = 'FETCH_RECIPES_BY_ID_PENDING'
export const FETCH_RECIPES_BY_ID_FAILED = 'FETCH_RECIPES_BY_ID_FAILED'
export const DELETE_RECIPE = 'DELETE_RECIPE'
export const DELETE_RECIPE_ERROR = 'DELETE_RECIPE_ERROR'
export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD'
export const PREPARE_RECIPE = 'PREPARE_RECIPE'
export const SELECT_MULTIPLE_RECIPES = 'SELECT_MULTIPLE_RECIPES'
export const SHOW_CHECKBOXES = 'SHOW_CHECKBOXES'
export const CHECK_ALL = 'CHECK_ALL'
export const SELECT_ALL = 'SELECT_ALL'
export const UNSELECT_ALL = 'UNSELECT_ALL'
export const SET_IMG_URL = 'SET_IMG_URL'
export const UNSELECT = 'UNSELECT'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_RECIPES_PER_PAGE = 'SET_RECIPES_PER_PAGE'
export const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES'
export const ADD_TO_FAVORITES_ERROR = 'ADD_TO_FAVORITES_ERROR'
export const SET_DATE = 'SET_DATE'
